module.exports = __webpack_public_path__ + "static/French-Onion-1385191f02589606a01d4b570e0c4282.png";